// extracted by mini-css-extract-plugin
module.exports = {"input-position":"styles_input-position__3_F9A"};